export const JWT_PLACEHOLDER = ":token";

const JWT_PATTERN = /eyJ[A-Za-z0-9_-]{5,}\.[A-Za-z0-9_-]{8,}(?:\.[A-Za-z0-9_-]*)?/g;

export function scrubJwt(value: string): string {
  return value.replace(JWT_PATTERN, JWT_PLACEHOLDER);
}
